import { Descriptions } from "antd";
import trans from "../../../../utils";
import {
  MapContainer,
  Marker,
  Polygon,
  TileLayer,
  useMap,
} from "react-leaflet";
import { Icon } from "leaflet";
import { useEffect } from "react";
import L from "leaflet";

const PoiTab = ({ data }) => {
  const area = data?.poi?.poiGeofences?.[0]?.geofence?.area;
  const diameter = data?.poi?.poiGeofences?.[0]?.geofence?.attributes?.diameter;
  const poiData = {
    name: data?.poi?.name || trans("No Data"),
    location: data?.poi?.address || trans("No Data"),
    lat: data?.poi?.latitude || trans("No Data"),
    lon: data?.poi?.longitude || "No Data",
    country: data?.poi?.country || trans("No Data"),
    city: data?.poi?.city || trans("No Data"),
    state: data?.poi?.state || trans("No Data"),
    type: data?.poi?.type || trans("No Data"),
  };

  const customIcon = new Icon({
    iconUrl: "https://www.svgrepo.com/show/513317/location-pin.svg",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  const items = [
    {
      label: trans("POI Name"),
      children: poiData.name,
      span: 4,
    },
    {
      label: trans("POI Location"),
      span: 4,
      children: poiData.location,
    },
    {
      label: trans("Latitude"),
      span: 2,
      children: poiData.lat,
    },
    {
      label: trans("Longitude"),
      span: 2,
      children: poiData.lon,
    },
    {
      label: trans("Type"),
      span: 2,
      children: poiData.type,
    },
    {
      label: trans("country"),
      span: 2,
      children: poiData.country,
    },
    {
      label: trans("city"),
      span: 2,
      children: poiData.city,
    },
    {
      label: trans("state"),
      span: 2,
      children: poiData.state,
    },
  ];

  function FlyToGeo({ area, diameter }) {
    const map = useMap();

    useEffect(() => {
      if (!area) return;

      // Parse WKT polygon
      const coordsString = area.replace("POLYGON ((", "").replace("))", "");

      const coords = coordsString.split(",").map((pair) => {
        const [lat, lng] = pair.trim().split(" ").map(Number);
        return [lat, lng];
      });

      // Compute polygon bounds
      const bounds = L.latLngBounds(coords);
      const center = bounds.getCenter();

      // Compute zoom level based on diameter
      // Smaller diameter -> larger zoom
      // Clamp between 12 and 20 for safety
      const zoom = 20 - Math.log2(diameter / 50); // adjust scaling
      const clampedZoom = Math.min(20, Math.max(12, zoom));

      // Fly to polygon center
      map.flyTo(center, clampedZoom, { duration: 1.5 });
    }, [area, diameter, map]);

    return null;
  }
  const polygonCoords = area
    ? area
        .replace("POLYGON ((", "")
        .replace("))", "")
        .split(",")
        .map((pair) => {
          const [lat, lng] = pair.trim().split(" ").map(Number);
          return [lat, lng];
        })
    : null;

  console.log("area", area, "diameter", diameter, "data", data);
  return (
    <div>
      <Descriptions
        title={
          <div className="fs-16 fw-700 brand-700">
            {trans("Point of Interest (POI)")}
          </div>
        }
        size={"small"}
        bordered
        items={items.map((item) => ({
          ...item,
          labelStyle: { width: "150px" }, // adjust here
        }))}
        style={{ marginBottom: 24 }}
      />
      <Descriptions
        title={
          <div className="fs-16 fw-700 brand-700">
            {trans("POI Preview + Geofence")}
          </div>
        }
      />
      <MapContainer
        center={[poiData.lat, poiData.lon]}
        zoom={15}
        style={{
          marginBlock: "15px",
          height: "250px",
          width: "100%",
          borderRadius: "8px",
        }}
      >
        <FlyToGeo area={area} diameter={diameter} />
        {data?.enableGeofencing && polygonCoords && (
          <Polygon
            positions={polygonCoords}
            pathOptions={{ color: "#2E9245", fillOpacity: 0.2 }}
          />
        )}
        <TileLayer url="https://mt0.google.com/vt/lyrs=m,&hl=en&x={x}&y={y}&z={z}&s=Ga" />
        <Marker position={[poiData.lat, poiData.lon]} icon={customIcon} />
      </MapContainer>
    </div>
  );
};

export default PoiTab;
